module.exports = __webpack_public_path__ + "img/delete-field-icon.34275bbe.svg";